(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fdg-brands-directory"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-fdg-brands]');
  if (!root) return;

  const data = root.querySelector('#FDGBrandData');
  const grid = root.querySelector('#FDGAllBrandGrid');
  const search = root.querySelector('#FDGBrandSearch');
  const count = root.querySelector('#FDGBrandCount');
  const empty = root.querySelector('#FDGBrandEmpty');
  const alphabet = root.querySelector('#FDGBrandAlphabet');
  const rawBrands = JSON.parse(data?.textContent || '[]');
  const brands = [...new Map(rawBrands.map((brand) => [String(brand).trim().toLocaleLowerCase(), String(brand).trim()])).values()].filter(Boolean).sort((a, b) => a.localeCompare(b));
  const countTemplate = root.dataset.countTemplate || '__VISIBLE__ of __TOTAL__ brands shown';
  const shopLabel = root.dataset.shopLabel || 'Shop __BRAND__ products';
  let activeLetter = '';

  const brandUrl = (brand) => `/collections/vendors?q=${encodeURIComponent(brand)}`;
  const render = () => {
    const term = search.value.trim().toLocaleLowerCase();
    const visible = brands.filter((brand) => {
      const matchesSearch = !term || brand.toLocaleLowerCase().includes(term);
      const first = brand.charAt(0).toLocaleUpperCase();
      const matchesLetter = !activeLetter || (activeLetter === '#' ? !/[A-Z]/.test(first) : first === activeLetter);
      return matchesSearch && matchesLetter;
    });

    grid.replaceChildren(...visible.map((brand) => {
      const link = document.createElement('a');
      link.href = brandUrl(brand);
      link.textContent = brand;
      link.setAttribute('aria-label', shopLabel.replace('__BRAND__', brand));
      return link;
    }));
    count.textContent = countTemplate.replace('__VISIBLE__', visible.length).replace('__TOTAL__', brands.length);
    empty.hidden = visible.length !== 0;
  };

  ['All', '#', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'].forEach((letter) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = letter;
    button.className = letter === 'All' ? 'is-active' : '';
    button.addEventListener('click', () => {
      activeLetter = letter === 'All' ? '' : letter;
      alphabet.querySelectorAll('button').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
      render();
    });
    alphabet.append(button);
  });

  search.addEventListener('input', render);
  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fdg-halloween-popup"]) return;
  try {
    
  if (!customElements.get('fdg-halloween-popup')) {
    customElements.define('fdg-halloween-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.abort = new AbortController();
        const options = {signal: this.abort.signal};
        this.key = 'fdg-halloween-2026-1859295641844';
        this.started = Date.now();
        try {
          if (sessionStorage.getItem(this.key + '-shown')) return;
          const saved = Number(sessionStorage.getItem(this.key + '-started'));
          if (saved > 0 && saved <= Date.now()) this.started = saved;
          else sessionStorage.setItem(this.key + '-started', String(this.started));
        } catch (_) {}
        this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
        this.dialog.addEventListener('click', event => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => clearInterval(this.timer), options);
        this.tick();
        this.timer = setInterval(() => this.tick(), 500);
      }
      tick() {
        const now = Date.now();
        if (now < Date.parse(this.dataset.start) || now >= Date.parse(this.dataset.end)) {
          if (this.dialog.open) this.dialog.close();
          clearInterval(this.timer);
          return;
        }
        if (this.dialog.open || this.shown || document.hidden || now - this.started < Number(this.dataset.delay) * 1000) return;
        if (document.querySelector('dialog[open], [aria-modal="true"]') || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return;
        this.dialog.showModal();
        this.shown = true;
        try { sessionStorage.setItem(this.key + '-shown', '1'); } catch (_) {}
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.dialog?.open) this.dialog.close();
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fdg-studio-sale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fdg-sale-carousel')) {
    customElements.define('fdg-sale-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.rows = [];
        this.querySelectorAll('[data-studio-sale-start]').forEach(sale => {
          const grid = sale.querySelector('.fdg-studio-sale-grid');
          if (!grid) return;
          const cards = Array.from(grid.children);
          const controls = this.querySelector('[data-controls]').content.firstElementChild.cloneNode(true);
          sale.append(controls);
          const row = {sale, cards, controls, index: 0, paused: this.dataset.autoplay === 'false' || this.motion.matches, last: Date.now()};
          controls.querySelector('[data-previous]').addEventListener('click', () => this.move(row, -1), options);
          controls.querySelector('[data-next]').addEventListener('click', () => this.move(row, 1), options);
          controls.querySelector('[data-pause]').addEventListener('click', () => { row.paused = !row.paused; row.last = Date.now(); this.draw(row); }, options);
          this.rows.push(row);
        });
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.rows.forEach(row => { row.paused = true; this.draw(row); }); }, options);
        this.tick();
        this.timer = setInterval(() => this.tick(), 250);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.controller?.abort();
        this.rows?.forEach(row => row.controls.remove());
        this.controller = null;
      }
      count() { return innerWidth < 600 ? 1 : innerWidth < 900 ? 2 : 3; }
      move(row, direction) {
        row.index = (row.index + direction + row.cards.length) % row.cards.length;
        row.last = Date.now();
        this.draw(row);
      }
      draw(row) {
        const count = Math.min(this.count(), row.cards.length);
        row.cards.forEach((card, index) => {
          const position = (index - row.index + row.cards.length) % row.cards.length;
          card.hidden = position >= count;
          card.style.order = position;
        });
        row.controls.hidden = row.cards.length <= count;
        row.controls.querySelector('[data-position]').textContent = Array.from({length: count}, (_, i) => (row.index + i) % row.cards.length + 1).join(' · ') + ' / ' + row.cards.length;
        const button = row.controls.querySelector('[data-pause]');
        button.textContent = row.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      }
      tick() {
        const now = Date.now();
        const seconds = Math.max(3, Math.min(20, Number(this.dataset.seconds) || 5));
        let visible = false;
        this.rows.forEach(row => {
          row.sale.hidden = !(Date.parse(row.sale.dataset.studioSaleStart) <= now && now < Date.parse(row.sale.dataset.studioSaleEnd));
          if (!row.sale.hidden) visible = true;
          if (row.sale.hidden || document.hidden || row.paused || row.sale.matches(':hover') || row.sale.contains(document.activeElement)) row.last = now;
          if (now - row.last >= seconds * 1000 && row.cards.length > this.count()) this.move(row, 1);
          this.draw(row);
        });
        this.hidden = !visible;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
